<template>
    <div class="yk-exam-info clearfix">
        <div class="top-page-top">
            <span class="sp-top-text">
                <span>考试信息管理</span>
            </span>
        </div>

        <el-form label-width="180px" :rules="rules" ref="form" :model="form" class="change-user-password-form">
            <el-form-item label="考试标题" prop="ExamTitle">
                <el-input v-model="form.ExamTitle"></el-input>
            </el-form-item>
            <el-form-item label="考试时间安排" prop="ExamTimeUrl">
                <imageUpload :url="urlAliyunOSS" :files.sync="form.ExamTimeUrl" format="image"></imageUpload>
                <!-- <el-input v-model="form.ExamTimeUrl"></el-input> -->
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="save('form')">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
export default {
    data() {
        return {
            form: {
                Id: "",
                ExamTitle: "",
                ExamTimeUrl: "",
            },
            rules: {
                ExamTitle: [{ required: true, message: "请输入", trigger: "blur" }],
                ExamTimeUrl: [{ required: true, message: "请输入", trigger: "blur" }],
            },
            urlAliyunOSS: "/api/XOrg/AssociationIndex/getSign",
        };
    },
    components: {
        imageUpload,
    },
    created() {
        this.getFileUrlList();
    },
    methods: {
        save(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    var that = this;
                    that.$http
                        .post("/api/XOrg/FileManager/addOrEditExamInfo", {
                            Id: that.form.Id,
                            ExamTitle: that.form.ExamTitle,
                            ExamTimeUrl: that.form.ExamTimeUrl,
                        })
                        .then(function(rst) {
                            if (rst.code > 0) {
                                that.getFileUrlList();
                                that.$message.success(rst.msg);
                            } else {
                                that.$message.warning(rst.msg);
                            }
                        });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        //查询
        getFileUrlList() {
            var that = this;
            this.$http.post("/api/XOrg/FileManager/getFileUrlList").then(function(rst) {
                if (rst.code > 0 && rst.list != null) {
                    that.form = rst.list;
                } else {
                    that.$message.warning(rst.msg);
                }
            });
        },
    },
};
</script>

<style lang="scss">
.yk-exam-info {
    background: #fff;
    padding-bottom: 20px;
    .change-user-password-form {
        width: 800px;
        margin-top: 30px;
    }
    .add-partner-enterprise-head {
        border-bottom: 1px solid #f0f0f0;
        height: 60px;
        .add-banner-btn,
        .delete-banner-btn {
            margin-top: 13px;
        }
        .delete-banner-btn {
            margin-right: 62px;
        }
        .top-page-top {
            border: none;
        }
    }
    .banner-page-con {
        padding: 20px 0;
        text-align: center;
    }
    .el-table thead {
        color: #05243D;
    }
    .btn-right {
        margin-top: 14px;
    }
    .export-button-a {
        color: #fff;
        background: #409eff;
        padding: 8px 15px;
        border-radius: 4px;
        margin: 0 10px;
    }
}
</style>
